import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=ae8bd984&scoped=true&"
import script from "./step3.vue?vue&type=script&lang=js&"
export * from "./step3.vue?vue&type=script&lang=js&"
import style0 from "./step3.vue?vue&type=style&index=0&id=ae8bd984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8bd984",
  null
  
)

export default component.exports